// extracted by mini-css-extract-plugin
module.exports = {"loading":"SelfStudyV2_loading__iR05E","container":"SelfStudyV2_container__2gr4P","breadcrumbs":"SelfStudyV2_breadcrumbs__DItFe","bc-item":"SelfStudyV2_bc-item__14L0s"};